// extracted by mini-css-extract-plugin
module.exports = {"banner_con":"style_banner_con__2AU0-","banner_title":"style_banner_title__2V5a-","banner_desc":"style_banner_desc__2KLmZ"};